import * as angular from 'angular';
import {
    FeatureTogglesResource,
    FeatureToggles
} from 'angular/resources/feature-toggles.resource';
import { config } from 'angular/utils/config';

type StorageAdminViewType = 'premium-services';

class StorageSettingsComponentCtrl implements ng.IController {
    public activeSetting: StorageAdminViewType;
    public featureToggles: FeatureToggles;
    public authenticatedUser: LoginResult;
    public appBaseUrl = config.appBaseUrl;

    constructor(
        private $location: ng.ILocationService,
        private featureTogglesResource: FeatureTogglesResource
    ) {}

    $onInit(): void {
        this.featureTogglesResource
            .getUrls()
            .subscribe(
                (featureToggles) => (this.featureToggles = featureToggles)
            );

        if (!this.activeSetting) {
            this.activeSetting = 'premium-services';
        }
    }

    public isActiveUrl(url) {
        return url === this.$location.path();
    }
}

angular.module('app').component('pkpStorageSettings', {
    controller: StorageSettingsComponentCtrl,
    template: require('app/storage-admin/storage-settings.component.html'),
    bindings: {
        activeSetting: '=',
        authenticatedUser: '='
    }
});
